import { Box, Typography, Divider } from "@mui/material";

const VendorOnboard = () => {
  return (
    <Box>
      <Typography variant="h4" m={2}>
        Onboard Vendor
      </Typography>
      <Divider />
    </Box>
  );
};

export default VendorOnboard;
